import React from 'react';

const OrderReport = () => {
  return <div>OrderReport</div>;
};

export default OrderReport;
